import { TFunction } from "react-i18next";
import { api } from "src/services/Api/api";
import { ListConfigFilter } from "go-list/core/components/Filter/services/types";

interface OmitFilters {
	stockIdsFilter?: boolean;
	dateFilter?: boolean;
}

export const getCommonFilters = (t: TFunction, omitFilters?: OmitFilters) => {
	const commonFilters: ListConfigFilter[] = [
		{
			id: "product_ids",
			name: t("common.word.product"),
			type: "search_select",
			source: {
				request: (search: string, params: Record<string, any>, options?: Record<string, any>) =>
					api.organization().getProductSearchSelect(search, params, {
						cancelToken: options?.token,
					}),
			},
			hasDefaultOptions: false,
		},
		{
			id: "category_ids",
			name: t("common.word.category"),
			type: "search_select",
			source: {
				request: (search: string, params: Record<string, any>, options?: Record<string, any>) =>
					api.organization().getProductCategorySearchSelect(search, params, {
						cancelToken: options?.token,
					}),
			},
			hasDefaultOptions: false,
		},
		{
			id: "product_statuses",
			name: t("common.word.product_status"),
			type: "list",
			listOptions: {
				ENABLED: t("enums.common.status.ENABLED", { ns: "lib" }),
				DISABLED: t("enums.common.status.DISABLED", { ns: "lib" }),
				DELETED: t("enums.common.status.DELETED", { ns: "lib" }),
			},
			hasDefaultOptions: false,
		},
		{
			id: "product_barcode",
			name: t("modules.product.field.product_barcode.title"),
			type: "text",
		},
	];

	if (!omitFilters?.dateFilter) {
		commonFilters.push({
			id: "date_range",
			name: t("common.word.date", { ns: "lib" }),
			type: "date",
			typeOptions: ["bt"],
		});
	}

	if (!omitFilters?.stockIdsFilter) {
		commonFilters.push({
			id: "stock_ids",
			name: t("common.word.stock"),
			type: "search_select",
			source: {
				request: (search: string, params: Record<string, any>, options?: Record<string, any>) =>
					api.organization().getStockSearchSelect(search, params, {
						cancelToken: options?.token,
					}),
			},
			hasDefaultOptions: false,
		});
	}

	return commonFilters;
};
